/**
 * Search modal: toggles "top suggestions" vs typed predictive results.
 */
(function () {
  var PRODUCT_GRID_CLASS = 'predictive-search-modal__product-grid';

  var SEL = {
    modal: '.predictive-search-modal',
    input: '[data-predictive-search-input]',
    suggestions: '.js-predictive-search-suggestions',
    popularRoot: '[data-popular-products-root]',
    popularGrid: '[data-popular-products-grid]',
    popularPlaceholder: '[data-popular-products-placeholder]',
  };

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function asInt(v, fallback) {
    var n = parseInt(String(v || ''), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function syncSuggestions(panel) {
    var input = panel.querySelector(SEL.input);
    var suggestions = panel.querySelector(SEL.suggestions);
    if (!input || !suggestions) return;
    var empty = !input.value || !String(input.value).trim();

    // Show initial recommendations only when query is empty.
    if (empty) {
      suggestions.classList.add('is-active');
      suggestions.style.display = '';
      ensurePopularLoaded(panel);
      return;
    }

    suggestions.classList.remove('is-active');
    suggestions.style.display = 'none';
  }

  function renderPredictiveLoadingSkeleton(panel) {
    var results = panel.querySelector('[data-predictive-search-results]');
    if (!results) return;

    var pillCount = 6;

    results.innerHTML =
      // Categories skeleton (pills)
      '<div class="predictive-search-modal__suggestions-section">' +
      '  <h3 class="predictive-search-modal__heading fw-700">Categories</h3>' +
      '  <div class="swiper predictive-search-modal__pills-swiper" data-boost-skeleton-categories>' +
      '    <div class="swiper-wrapper" role="list" data-boost-skeleton-categories-wrapper></div>' +
      '  </div>' +
      '</div>' +
      '<div class="predictive-search-modal__popular-section">' +
      '  <h3 class="predictive-search-modal__heading fw-700">Products</h3>' +
      '  <div class="' + PRODUCT_GRID_CLASS + '" data-boost-skeleton-grid></div>' +
      '</div>';

    var catWrap = results.querySelector('[data-boost-skeleton-categories-wrapper]');
    if (catWrap) {
      for (var p = 0; p < pillCount; p++) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.setAttribute('role', 'listitem');
        slide.innerHTML = '<span class="predictive-search-modal__pill predictive-search-modal__pill--skeleton">&nbsp;</span>';
        catWrap.appendChild(slide);
      }
    }

    var grid = results.querySelector('[data-boost-skeleton-grid]');
    if (!grid) return;
    for (var i = 0; i < 6; i++) {
      var skeleton = document.createElement('div');
      skeleton.className = 'predictive-search-modal__product-card--skeleton';
      skeleton.setAttribute('aria-hidden', 'true');
      grid.appendChild(skeleton);
    }
  }

  function buildModalResultsHtml(query, data) {
    var d = data || {};
    var products = Array.isArray(d.products) ? d.products : [];
    var collections = Array.isArray(d.collections) ? d.collections : [];
    var keywords = Array.isArray(d.suggestions) ? d.suggestions : Array.isArray(d.did_you_mean) ? d.did_you_mean : [];
    var totalProducts = typeof d.total_product === 'number' ? d.total_product : products.length;

    // UI limits to keep modal light
    keywords = keywords.slice(0, 10);
    collections = collections.slice(0, 8);
    var html = '';

    // Suggestions + Collections in same UI under "Categories"
    if (keywords.length || collections.length) {
      html += '<div class="predictive-search-modal__suggestions-section">';
      html += '<h3 class="predictive-search-modal__heading fw-700">Categories</h3>';
      html += '<div class="swiper predictive-search-modal__pills-swiper" data-id="boostCategoriesSwiper">';
      html += '<div class="swiper-wrapper" role="list">';

      // 1) suggestion keywords first
      keywords.forEach(function (k) {
        var q = String(k || '').trim();
        if (!q) return;
        var url = '/search?q=' + encodeURIComponent(q);
        html += '<div class="swiper-slide" role="listitem">';
        html += '<a class="predictive-search-modal__pill" href="' + escapeHtml(url) + '">' + escapeHtml(q) + '</a>';
        html += '</div>';
      });

      // 2) then collections
      collections.forEach(function (c) {
        var handle = c && c.handle ? String(c.handle) : '';
        if (!handle) return;
        var title = (c && c.title) || handle;
        var url = '/collections/' + encodeURIComponent(handle);
        html += '<div class="swiper-slide" role="listitem">';
        html += '<a class="predictive-search-modal__pill" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>';
        html += '</div>';
      });

      html += '</div></div></div>';
    }

    html += '<div class="predictive-search-modal__popular-section">';
    html += '<div class="predictive-search-modal__section-head">';
    html += '<h3 class="predictive-search-modal__heading fw-700">Products (' + escapeHtml(String(totalProducts)) + ' results)</h3>';
    if (products.length > 0) {
      html += '<a class="predictive-search-modal__view-all" href="/search?q=' + encodeURIComponent(String(query || '').trim()) + '">View all</a>';
    }
    html += '</div>';
    html += '<div class="predictive-search-modal__popular">';
    if (!products.length) {
      html += '<p class="predictive-search-modal__popular-placeholder"style="margin: 0 16px;">No products found for <strong>' + escapeHtml(query) + '</strong></p>';
    } else {
      html += '<div class="' + PRODUCT_GRID_CLASS + '" data-boost-products-grid></div>';
    }
    html += '</div></div>';

    return html;
  }

  function ensureSwiper(root) {
    if (!root || !window.Swiper) return;
    if (root.__swiper) return;
    root.__swiper = new window.Swiper(root, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      watchOverflow: true,
    });
  }

  function initInjectedProductCardSwipers(scope) {
    if (!scope || typeof window.swiperCards !== 'function') return;
    var uninitialized = scope.querySelectorAll('.collection-cardSwiper:not(.swiper-initialized)');
    if (!uninitialized.length) return;
    window.swiperCards('predictive-search-modal:auto-init', uninitialized);
  }

  function fetchProductGridItemHtml(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '?view=api-grid-item';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Product card request failed');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-api-content]');
        return root ? root.innerHTML : '';
      });
  }

  function renderProductsIntoGrid(scope, products, limit, gridSelector) {
    var selector = gridSelector || '[data-boost-products-grid]';
    var grid = scope && scope.querySelector(selector);
    if (!grid) return Promise.resolve();

    var handles = (products || [])
      .map(function (p) {
        return p && p.handle;
      })
      .filter(Boolean)
      .slice(0, limit || 12);

    if (!handles.length) {
      grid.innerHTML = '';
      return Promise.resolve();
    }

    return Promise.all(
      handles.map(function (h) {
        return fetchProductGridItemHtml(h).catch(function () {
          return '';
        });
      })
    ).then(function (cardsHtml) {
      var html = (cardsHtml || []).filter(Boolean).join('');
      grid.innerHTML = html;
      initInjectedProductCardSwipers(scope);
      return html;
    });
  }

  function fetchProductCardsHtml(products, limit) {
    var handles = (products || [])
      .map(function (p) {
        return p && p.handle;
      })
      .filter(Boolean)
      .slice(0, limit || 12);

    if (!handles.length) return Promise.resolve('');

    return Promise.all(
      handles.map(function (h) {
        return fetchProductGridItemHtml(h).catch(function () {
          return '';
        });
      })
    ).then(function (cardsHtml) {
      return (cardsHtml || []).filter(Boolean).join('');
    });
  }

  function renderSimpleProductSkeletonGrid(scope, count, gridSelector) {
    var selector = gridSelector || '[data-boost-products-grid]';
    var grid = scope && scope.querySelector(selector);
    if (!grid) return;
    var cardCount = typeof count === 'number' ? count : 6;
    grid.innerHTML = '';
    for (var i = 0; i < cardCount; i++) {
      var skeleton = document.createElement('div');
      skeleton.className = 'predictive-search-modal__product-card--skeleton';
      skeleton.setAttribute('aria-hidden', 'true');
      grid.appendChild(skeleton);
    }
  }

  function renderSearchResultsWithCards(panel, query, data, isStale) {
    var results = panel && panel.querySelector('[data-predictive-search-results]');
    if (!results) return Promise.resolve();

    return fetchProductCardsHtml(data && data.products, 12).then(function (cardsHtml) {
      if (typeof isStale === 'function' && isStale()) return;
      var html = buildModalResultsHtml(query, data);
      results.innerHTML = html;
      var grid = results.querySelector('[data-boost-products-grid]');
      if (grid && cardsHtml) grid.innerHTML = cardsHtml;
      ensureSwiper(panel.querySelector('[data-id="boostCategoriesSwiper"]'));
      initInjectedProductCardSwipers(results);
    });
  }

  function ensurePopularLoaded(panel) {
    var root = panel.querySelector(SEL.popularRoot);
    if (!root) return;
    if (root.getAttribute('data-loaded') === 'true') return;
    if (root.getAttribute('data-loading') === 'true') return;

    var grid = root.querySelector(SEL.popularGrid);
    if (!grid) return;

    var limit = asInt(root.getAttribute('data-popular-products-limit'), 6);

    root.setAttribute('data-loading', 'true');
    renderSimpleProductSkeletonGrid(root, limit, SEL.popularGrid);

    var boost = window.theme && window.theme.boostCommerceApi;
    var fetchPopular = boost && (
      (typeof boost.fetchPopularProducts === 'function' && boost.fetchPopularProducts) ||
      (typeof boost.popular === 'function' && boost.popular)
    );
    if (!fetchPopular) {
      root.removeAttribute('data-loading');
      root.setAttribute('data-loaded', 'true');
      grid.innerHTML = '';
      return;
    }

    fetchPopular(limit)
      .then(function (res) {
        var data = res && res.ok ? res.data : null;
        var products = (data && data.products) || [];
        return renderProductsIntoGrid(root, products, limit, SEL.popularGrid);
      })
      .then(function () {
        root.removeAttribute('data-loading');
        root.setAttribute('data-loaded', 'true');
        var placeholder = root.querySelector(SEL.popularPlaceholder);
        if (placeholder) {
          placeholder.style.display = grid.children.length ? 'none' : '';
        }
      })
      .catch(function (e) {
        console.warn('[predictive-search-modal] popular products failed', e);
        root.removeAttribute('data-loading');
        root.setAttribute('data-loaded', 'true');
        grid.innerHTML = '';
      });
  }

  function bindPanel(panel) {
    var input = panel.querySelector(SEL.input);
    var form = input && input.form;
    if (!input) return;

    var boostTriggerTimer = null;
    var cache = new Map();
    var abortController = null;
    var searchRunId = 0;
    var results = panel.querySelector('[data-predictive-search-results]');

    var suggestionsSwiperRoot = panel.querySelector('[data-id="predictiveSuggestionsSwiper"]');
    ensureSwiper(suggestionsSwiperRoot);

    function resetToInitialState() {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
      if (boostTriggerTimer) {
        window.clearTimeout(boostTriggerTimer);
        boostTriggerTimer = null;
      }
      if (input) input.value = '';
      if (results) results.innerHTML = '';
      syncSuggestions(panel);
    }

    input.addEventListener('input', function () {
      syncSuggestions(panel);

      var q = String(input.value || '').trim();
      var normalizedQ = q.toLowerCase();

      if (!q) {
        searchRunId += 1;
        if (abortController) abortController.abort();
        if (results) results.innerHTML = '';
        ensurePopularLoaded(panel);
        return;
      }

      searchRunId += 1;
      var runId = searchRunId;
      function isStale() {
        return runId !== searchRunId || String(input.value || '').trim().toLowerCase() !== normalizedQ;
      }

      // Always show skeleton first for any non-empty query.
      renderPredictiveLoadingSkeleton(panel);

      // If we already have cached markup for this keyword, swap it in immediately
      // (still showing skeleton first to match requested behavior).
      var keyImmediate = normalizedQ;
      if (cache.has(keyImmediate)) {
        if (boostTriggerTimer) window.clearTimeout(boostTriggerTimer);
        window.requestAnimationFrame(function () {
          var cachedData = cache.get(keyImmediate);
          if (!cachedData || !results) return;
          renderSearchResultsWithCards(panel, q, cachedData, isStale);
        });
        return;
      }

      if (boostTriggerTimer) window.clearTimeout(boostTriggerTimer);
      boostTriggerTimer = window.setTimeout(function () {
        var boost = window.theme && window.theme.boostCommerceApi;
        if (!boost || typeof boost.suggest !== 'function') return;

        var key = normalizedQ;
        if (cache.has(key)) {
          var cachedData = cache.get(key);
          if (!cachedData || !results) return;
          renderSearchResultsWithCards(panel, q, cachedData, isStale);
          return;
        }

        if (abortController) abortController.abort();
        abortController = new AbortController();

        boost
          .suggest(q, { signal: abortController.signal })
          .then(function (res) {
            if (isStale()) return;
            if (!res || !res.ok || !res.data) return;
            cache.set(key, res.data);
            return renderSearchResultsWithCards(panel, q, res.data, isStale);
          })
          .catch(function () {
            // ignore
          });
      }, 800);
    });

    // Ensure Enter in search input always performs a clean search redirect.
    // This avoids accidental submission of nested product-form fields from injected cards.
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var q = String(input.value || '').trim();
      if (!q) return;
      var target = '/search?q=' + encodeURIComponent(q);
      window.location.assign(target);
    });

    if (form) {
      form.addEventListener('reset', function () {
        requestAnimationFrame(function () {
          syncSuggestions(panel);
        });
      });
    }

    // Every open should start from the empty "initial" modal state.
    panel.addEventListener('theme:scroll:lock', function () {
      resetToInitialState();
    });

    syncSuggestions(panel);
  }

  window.theme = window.theme || {};
  window.theme.predictiveSearchModal = {
    init: function () {
      document.querySelectorAll(SEL.modal).forEach(bindPanel);
    },
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.theme.predictiveSearchModal.init();
  });
})();
